import "./singleMessage.css";
import { data } from "./data";
import { format } from "date-fns";
import Button from "../../Custom/Button/Button";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CloseIcon from "@mui/icons-material/Close";
import ReplyIcon from "@mui/icons-material/Reply";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RedoIcon from "@mui/icons-material/Redo";
import SendIcon from "@mui/icons-material/Send";
import { useEffect, useState } from "react";
import { useGlobalContext } from "../../../Context/Context";
import User from "../../picture/14.png";
import ForwardMessage from "./ForwardMessage";
import axios from "axios";

const SingleMessage = ({
  currentChat,
  setCurrentChat,
  currentTab,
  isFullVisible,
  selectedCompany,
}) => {
  const { setActiveIconsMiddleAdmin, activeIconsMiddleAdmin } =
    useGlobalContext();
  const { loggedUser, apiKey } = useGlobalContext();
  const { baseUrl } = useGlobalContext();

  const [searchTerm, setSearchTerm] = useState("");
  const [searchedMessages, setSearchMessages] = useState([]);
  const [currentMessage, setCurrentMessage] = useState("");
  const [localChat, setLocalChat] = useState(null);
  const [selectedMessage, setSelectedMessage] = useState({
    value: false,
    data: "",
  });
  const [isReply, setIsReply] = useState(false);
  const [isForward, setIsForward] = useState(false);

  const handleSearch = (isUp) => {
    if (searchTerm === "") return;
    if (searchedMessages.length === 0) {
      const newMessages = localChat.messages.filter((msg) =>
        msg.text.includes(searchTerm)
      );
      setSearchMessages(newMessages);
      setCurrentMessage(0);
    } else {
      if (isUp) {
        setCurrentMessage(
          currentMessage === searchedMessages.length - 1
            ? 0
            : currentMessage + 1
        );
      } else {
        setCurrentMessage(
          currentMessage === 0
            ? searchedMessages.length - 1
            : currentMessage - 1
        );
      }
    }
  };

  const handleChangeTerm = (e) => {
    setSearchTerm(e.target.value);
    setSearchMessages([]);
  };

  const setClassNameCheck = (id, sender) => {
    console.log(loggedUser.name, sender);
    if (loggedUser.name === sender) {
      return id === selectedMessage.data?.id
        ? "message current checked "
        : "message current";
    } else {
      return id === selectedMessage.data?.id
        ? "message other checked "
        : "message other";
    }
  };

  const setClassNameSelect = (id, sender) => {
    console.log(selectedCompany.company_chat_profile_id, sender);
    if (parseInt(selectedCompany.company_chat_profile_id) === sender) {
      return id === searchedMessages[currentMessage]?.id
        ? "message current selected"
        : "message current";
    } else {
      return id === searchedMessages[currentMessage]?.id
        ? "message other selected"
        : "message other";
    }
  };

  const handleCopy = async (message) => {
    try {
      await navigator.clipboard.writeText(message);
      setSelectedMessage({ value: false, data: "" });
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleSelectMessage = (message) => {
    setSelectedMessage({ value: true, data: message });
  };

  const handleCloseSelect = () => {
    setSelectedMessage({ value: false, data: "" });
  };

  //   const handleSendMessage = async () => {
  //     console.log(selectedCompany);
  //     const message =
  //       document.querySelectorAll(".message-input.msg")[isFullVisible ? 0 : 1];
  //     if (message.value === "") return;
  //     let newMessage = {
  //       id: 0,
  //       sender: selectedCompany.company_name,
  //       text: message.value,
  //       date: format(new Date(), "dd.MM.yyyy HH:mm"),
  //       reply: "",
  //     };
  //     try {
  //       const { data } = await axios.post(
  //         `${baseUrl}/admin_panel/chat/sendMessage.php`,
  //         {
  //           sender: selectedCompany.company_name,
  //           text: newMessage.text,
  //           date: newMessage.date,
  //           chat_room_id: parseInt(localChat.id),
  //           api_key: selectedCompany.external_api_key,
  //           // external_user_id: selectedCompany.company_chat_profile_id,
  //         }
  //       );
  //       newMessage = { ...newMessage, id: parseInt(data.message_id) };
  //       console.log(data.status);
  //       console.log(currentChat);
  //       console.log(isReply);

  //       if (isReply) {
  //         setIsReply(false);
  //         const response = await axios.post(
  //           `${baseUrl}/admin_panel/chat/sendReply.php`,
  //           {
  //             user_id: parseInt(selectedCompany.company_chat_profile_id),
  //             message_id: parseInt(data.message_id),
  //             reply_text: selectedMessage.data.text,
  //             api_key: selectedCompany.external_api_key,
  //           }
  //         );
  //         if (response.data.status === 200) {
  //           newMessage = {
  //             ...newMessage,
  //             reply: {
  //               sender: selectedMessage.data.sender,
  //               text: selectedMessage.data.text,
  //             },
  //           };
  //         }
  //       }

  //       const newMessages = [...localChat.messages, newMessage];
  //       setLocalChat({ ...localChat, messages: newMessages });
  //       if (currentChat.id === localChat.id)
  //         setCurrentChat({ ...currentChat, messages: newMessages });

  //       setSelectedMessage({ value: false, data: "" });
  //       message.value = "";
  //     } catch (e) {
  //       console.log(e);
  //       if (e.status === 404) {
  //       }
  //     }

  //     /*
  //     const data = JSON.parse(localStorage.getItem("messages"));
  //     const newData = data.map((chat) => {
  //       if (chat.id === localChat.id) {
  //         return { ...chat, messages: newMessages };
  //       } else return chat;
  //     });
  //     localStorage.setItem("messages", JSON.stringify(newData));
  // */
  //   };
  const handleSendMessage = async () => {
    console.log("Selected Company:", selectedCompany);
    console.log("Local Chat:", localChat);

    const messageInput = document.querySelector(".message-input.msg");
    if (!messageInput || messageInput.value.trim() === "") return;

    // Ensure localChat exists before accessing its ID
    if (!localChat || !localChat.id) {
      localChat.id = currentChat.cr_id;
    }

    console.log(selectedCompany);
    let newMessage = {
      id: 0,
      sender: selectedCompany.company_chat_profile_name,
      sender_id: parseInt(selectedCompany.company_chat_profile_id),
      text: messageInput.value.trim(),
      date: format(new Date(), "dd.MM.yyyy HH:mm"),
      reply: "",
    };

    try {
      console.log(currentChat);
      // Send message request with a validated chat_room_id
      const { data } = await axios.post(
        `${baseUrl}/admin_panel/chat/sendMessage.php`,
        {
          sender: selectedCompany.company_chat_profile_name,
          sender_id: parseInt(selectedCompany.company_chat_profile_id),
          text: newMessage.text,
          date: newMessage.date,
          chat_room_id: parseInt(localChat.id), // ✅ Now guaranteed to be a valid ID
          api_key: selectedCompany.external_api_key,
        }
      );

      newMessage = { ...newMessage, id: parseInt(data.message_id) };

      console.log("DATA PORUKE: ", data);
      console.log("Message Sent Status:", data.status);
      console.log("Current Chat:", currentChat);

      if (isReply) {
        setIsReply(false);
        const response = await axios.post(
          `${baseUrl}/admin_panel/chat/sendReply.php`,
          {
            user_id: parseInt(selectedCompany.company_chat_profile_id),
            message_id: parseInt(data.message_id),
            reply_text: selectedMessage.data.text,
            api_key: selectedCompany.external_api_key,
          }
        );
        if (response.data.status === 200) {
          newMessage = {
            ...newMessage,
            reply: {
              sender: selectedMessage.data.sender,
              text: selectedMessage.data.text,
            },
          };
        }
      }

      const newMessages = [...localChat.messages, newMessage];
      setLocalChat({ ...localChat, messages: newMessages });

      if (currentChat?.id === localChat.id) {
        setCurrentChat({ ...currentChat, messages: newMessages });
      }

      setSelectedMessage({ value: false, data: "" });
      messageInput.value = ""; // Clear input after sending

    } catch (error) {
      console.error("Error Sending Message:", error);
    }
  };

  useEffect(() => {
    if (searchedMessages.length !== 0) {
      let containers = document.querySelectorAll(".left-side-message-wrapper");
      let container;
      if (containers[1] === undefined && !isFullVisible)
        container = containers[0];
      else if (!isFullVisible) container = containers[1];
      else container = containers[0];

      console.log(container, searchedMessages, currentMessage);
      console.log(
        container?.querySelector(
          `[id='${searchedMessages[currentMessage].id}']`
        )
      );
      if (container !== null) {
        container
          ?.querySelector(`[id='${searchedMessages[currentMessage].id}']`)
          .scrollIntoView();
      }
    }
  }, [currentMessage]);

  useEffect(() => {
    console.log(currentChat)
    if(currentChat === null) return;
   
      let currentActive = activeIconsMiddleAdmin.find(
      (icon) => icon.name === currentTab
    );
    console.log(localChat, currentActive, currentChat);

    if (isFullVisible) setLocalChat(currentChat);
    if (
      !isFullVisible &&
      currentChat !== null &&
      currentActive !== undefined &&
      currentActive.data.id !== currentChat.id
    ) {
      console.log("Ovde se poziva slanje drugom");
      const fetchExternalChat = async () => {
        try {
          const { data } = await axios.post(
            `${baseUrl}/admin_panel/chat/getAllMessages.php`,
            {
              chat_room_id: parseInt(currentActive.data.id),
              api_key_company: selectedCompany.external_api_key,
              external_user_id: selectedCompany.company_chat_profile_id,
            }
          );
          console.log(data);
          if (data.status === 200) {
            let newMessages = {
              ...currentActive.data,
              messages: data.messages,
            };
            setLocalChat(newMessages);
            setSearchMessages([]);
            setCurrentMessage("");
            setSearchTerm("");
          }
        } catch (e) {
          console.log(e);
          if (e.status === 404) {
          }
        }
      };
      fetchExternalChat();
      
    }
    

    if (
      !isFullVisible &&
      currentActive !== undefined &&
      currentActive.data.id === currentChat.id
    ) {
      console.log("OTVARAM VELIKI PROZOR - MESSENGER")
      setLocalChat(currentChat);
      setSearchMessages([]);
      setCurrentMessage("");
      setSearchTerm("");
      const messageInputs = document.querySelectorAll(".message-input");
      if (messageInputs.length === 2) messageInputs[0].value = "";
      else messageInputs[2].value = "";
    }
  }, [currentChat, activeIconsMiddleAdmin]);

  useEffect(() => {
    if (localChat !== null) {
      let containers = document.querySelectorAll(".left-side-message-wrapper");
      let container;
      if (!isFullVisible) container = containers[1];
      else container = containers[0];
      console.log(container);
      console.log(localChat);
      if (localChat.messages.length > 0) {
        console.log(localChat.messages[localChat.messages.length - 1].id);
        container
          ?.querySelector(
            `[id='${localChat.messages[localChat.messages.length - 1].id}']`
          )
          ?.scrollIntoView();
      }
    }
  }, [localChat]);

  return (
    <>
      <div className="left-side-message-wrapper">
        <div
          className={`${selectedMessage.value ? `message-header blocked` : `message-header`
            } `}
        >
          <div className="btn-up" onClick={() => handleSearch(false)}>
            <Button activation={true}>
              <KeyboardArrowUpIcon />
            </Button>
          </div>
          <input
            className={`${selectedMessage.value ? `message-input blocked` : `message-input`
              } `}
            placeholder="Search..."
            onChange={handleChangeTerm}
          />
          <div className="btn-down" onClick={() => handleSearch(true)}>
            <Button activation={true}>
              <KeyboardArrowDownIcon />
            </Button>
          </div>
        </div>
        <div className="message-chat">
          {localChat !== null &&
            localChat.messages.map((msg, index) => {
              console.log(index, msg);
              const { id, sender_id, sender, text, date } = msg;
              const dateYear = date.split(" ")[0];
              const dateTime = date.split(" ")[1];

              return (
                <article
                  id={id}
                  className={
                    selectedMessage.value
                      ? setClassNameCheck(id, sender_id)
                      : setClassNameSelect(id, sender_id)
                  }
                  key={index}
                  onDoubleClick={() => handleSelectMessage(msg)}
                  onTouchStart={() => handleSelectMessage(msg)}
                >
                  {msg.reply !== "" && (
                    <div className="msg-reply">
                      <ReplyIcon />
                      <div className="msg-reply-information">
                        <span>{msg.reply.sender}</span>
                        <span>{msg.reply.text}</span>
                      </div>
                    </div>
                  )}
                  <div className="sender-icon-name">
                    <img src={User} alt="" />
                    <span className="msg-data">{sender}</span>
                  </div>
                  <span className="msg-text">{text}</span>
                  <div className="wrapper-message-date-time">
                    <span>{dateYear}</span>
                    <span>{dateTime}</span>
                  </div>
                </article>
              );
            })}
        </div>
        <div className="message-footer">
          {selectedMessage.value ? (
            <>
              {isReply ? (
                <>
                  <div className="message-replay">
                    <div className="message-replay-information">
                      <div className="message-sender">
                        {selectedMessage.data.sender}
                      </div>
                      <div className="message-text">
                        {selectedMessage.data.text}
                      </div>
                    </div>
                    <div
                      className="msg-select-button"
                      onClick={() => setIsReply(false)}
                    >
                      <Button activation={true}>
                        <CloseIcon />
                      </Button>
                    </div>
                  </div>
                  <input className="message-input msg" />
                  <div className="btn-send" onClick={handleSendMessage}>
                    <Button activation={true}>
                      <SendIcon />
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <div className="msg-footer-select-left">
                    <div
                      className="msg-select-button"
                      onClick={handleCloseSelect}
                    >
                      <Button activation={true}>
                        <CloseIcon />
                      </Button>
                    </div>
                    <span>1 selected</span>
                  </div>
                  <div className="msg-footer-select-right">
                    <div
                      className="msg-select-button"
                      onClick={() => setIsReply(true)}
                    >
                      <Button activation={true}>
                        <ReplyIcon />
                      </Button>
                    </div>
                    <div
                      className="msg-select-button"
                      onClick={() => handleCopy(selectedMessage.data.text)}
                    >
                      <Button activation={true}>
                        <ContentCopyIcon />
                      </Button>
                    </div>
                    <div
                      className="msg-select-button"
                      onClick={() => setIsForward(true)}
                    >
                      <Button activation={true}>
                        <RedoIcon />
                      </Button>
                    </div>
                  </div>{" "}
                </>
              )}
            </>
          ) : (
            <>
              <input className="message-input msg" />
              <div className="btn-send" onClick={handleSendMessage}>
                <Button activation={true}>
                  <SendIcon />
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
      {isForward && (
        <ForwardMessage
          setSelectedMessage={setSelectedMessage}
          setIsForward={setIsForward}
          selectedMessage={selectedMessage}
          isFullVisible={isFullVisible}
          localChat={localChat}
          setLocalChat={setLocalChat}
          currentTab={currentTab}
          selectedCompany={selectedCompany}
        />
      )}
    </>
  );
};

export default SingleMessage;
